
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface SettingsFooterProps {
  language: Language;
  onClose: () => void;
}

const SettingsFooter: React.FC<SettingsFooterProps> = ({ language, onClose }) => {
  const t = TRANSLATIONS[language];
  return (
    <div className="p-4 border-t border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/[0.01] shrink-0">
      <button onClick={onClose} className="w-full py-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-[11px] font-black shadow-lg shadow-emerald-500/20 active:scale-95 transition-all flex items-center justify-center gap-2">
        <i className="fas fa-check"></i>
        {t.save}
      </button>
    </div>
  );
};
export default SettingsFooter;
